var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "relative lg:min-h-screen"
  }, [_c('div', {
    staticClass: "feature-image-wrapper shadow-inner h-200 md:h-340 lg:h-640 xl:h-740 md:w-340 lg:w-640 xl:w-740 md:absolute top-0 right-0"
  }, [_c('parallax', [_c('cdn-image', {
    attrs: {
      "src": _vm.image,
      "alt": _vm.title ? _vm.title : _vm.$t(_vm.langPrefix + '.title'),
      "size": {
        width: '100vw',
        ratio: 2,
        md: {
          width: 340,
          ratio: 1
        },
        lg: {
          width: 640,
          ratio: 1
        },
        xl: {
          width: 740,
          ratio: 1
        }
      },
      "max-width": 800,
      "cover": "",
      "immediate": ""
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "relative md:static feature-image-content bg-white"
  }, [_c('container', [_c('div', {
    staticClass: "flex items-center lg:min-h-screen w-full md:max-w-400 lg:max-w-500"
  }, [_c('div', {
    staticClass: "mb-32 md:mb-96 pt-24 md:pt-48"
  }, [_vm.$device.isDesktop || !_vm.hideTitleOnMobile ? _c('div', {
    staticClass: "flex flex-column items-start mb-24"
  }, [_vm.newBadge ? _c('badge', {
    staticClass: "text-uppercase mb-8",
    attrs: {
      "color": "secondary",
      "rounded-large": "",
      "spaced": "",
      "large": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('label.new')))]) : _vm.betaBadge ? _c('badge', {
    staticClass: "text-uppercase mb-8",
    attrs: {
      "color": "secondary",
      "rounded-large": "",
      "spaced": "",
      "large": ""
    }
  }, [_vm._v("BETA")]) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "mb-0 font-bold feature-screen-title",
    domProps: {
      "innerHTML": _vm._s(_vm.title ? _vm.title : _vm.$t(_vm.langPrefix + '.title'))
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.showDescription ? _c('p', {
    staticClass: "font-heading text-md sm:text-lg leading-wide mb-24 w-full",
    domProps: {
      "innerHTML": _vm._s(_vm.description ? _vm.description : _vm.$t(_vm.langPrefix + '.description'))
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("description"), _vm._v(" "), _vm.$slots.default ? _c('div', {
    staticClass: "w-full"
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), _vm.$slots.cta ? _c('wrapper', {
    staticClass: "w-full mt-20 sm:mt-24 md:mt-32",
    attrs: {
      "grow": "",
      "left": "",
      "break-column": "xs",
      "break-reverse": ""
    }
  }, [_vm._t("cta")], 2) : _vm._e()], 2)])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }